import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { AppEnv } from '@core/services';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const env = window['__env__'] as AppEnv;

if (env.enableProdMode) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
